// @flow

// The line above the input
export const Baseline = {
  display: 'none',
}
